import db from '@/firebase/init'
import {firestore} from 'firebase/app'


export async function getFirebaseCollection(collectionName: string) {
    const collection = db.collection(collectionName).orderBy('date_created', 'desc')
    const data = []
    await collection.get()
    .then(snapshot => {
      snapshot.forEach(doc => {
        data.push( {id: doc.id, data: doc.data()} )
      })
    })
    .catch(err => {
      console.log('Error getting documents', err)
    })
  return data
}

export async function getFirebaseCollectionWhere(collectionName: string, field: string | firestore.FieldPath, parameter: boolean) {
  console.log('getFirebaseCollectionWhere Function')
  const collection = db.collection(collectionName).where(field, '==', parameter).orderBy('date_created', 'desc')
  const data = []
  await collection.get()
  .then(snapshot => {
    snapshot.forEach(doc => {
      data.push( {id: doc.id, data: doc.data()} )
    })
  })
  .catch(err => {
    console.log('Error getting documents', err)
  })
return data
}


export async function getFirebaseCollectionWhereDual(collectionName: string, field: string | firestore.FieldPath, parameter: boolean, field2: string | firestore.FieldPath, parameter2: boolean) {
  console.log('getFirebaseCollectionWhereDual Function')
  const collection = db.collection(collectionName).where(field, '==', parameter).where(field2, '==', parameter2).orderBy('date_created', 'desc')
  const data = []
  await collection.get()
  .then(snapshot => {
    snapshot.forEach(doc => {
      data.push( {id: doc.id, data: doc.data()} )
    })
  })
  .catch(err => {
    console.log('Error getting documents', err)
  })
return data
}





export async function getFirebaseDocumentFromCollection(collectionName: string, documentId: string){
  console.log('getFirebaseDocumentFromCollection Function')
  var docRef = db.collection(collectionName).doc(documentId);
  const data = []
  await docRef.get()
  .then(function(doc) {
    if (doc.exists) {
      data.push(doc.data())
    } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
        console.log(documentId + ' does not exist')
    }
    }).catch(function(error) {
      console.log("Error getting document:", error);


});

return data

}


export async function searchFirebaseCollectionInArray(collectionName: string, field: string, parameter: string){
  console.log('searchFirebaseCollectionInArray Function')
  console.log(collectionName)
  console.log(field)
  const collection = db.collection(collectionName)
  const data = []
  const query = collection.where(field, 'array-contains', parameter)
  await query.get().then(snapshot => {
    snapshot.docs.forEach(doc => {
      data.push(doc.id)
    })
  })
  return data
}

export async function getFirebaseCollectionNoOrder(collectionName: string) {
  console.log('getFirebaseCollectionNoOrder Function')
  const collection = db.collection(collectionName)
  const data = []
  await collection.get()
  .then(snapshot => {
    snapshot.forEach(doc => {
      data.push( {id: doc.id, data: doc.data()} )
    })
  })
  .catch(err => {
    console.log('Error getting documents', err)
  })
return data
}
export async function updateFirebaseDocument(collectionName: string, documentId: string, field: any, updateValue: any) {
    var doc = db.collection(collectionName).doc(documentId)
    var field = field
    console.log(doc)
    return doc.update({
        [field]: updateValue
    })
    .then(function() {
        console.log("Document successfully updated!");
    })
    .catch(function(error) {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });
}

export function getImageUrlViaResolution (fileName: string, resolution: number, bucketName: string) {
  const split = fileName.split('.')
  const filename = split[0]
  const extension = split[1]
  const bucket = bucketName || 'skypet_blog_images'
  const baseUrl = 'https://storage.googleapis.com/'
  let res = null
  if (!resolution) { res = '' }
  if (resolution === 1920) { res = '@s_1920' }
  if (resolution === 720) { res = '@s_720' }
  if (resolution === 100) { res = '@s_100' }
  const imageUrl = baseUrl + bucket + '/' + filename + res + '.' + extension
  return imageUrl
}


export function postBlogToFirebase (blog: { body: any }, selectedCoverImage: any, author: any, title: any, status: any, tags: any[], project: boolean) {
  const date = new Date()
  db.collection(process.env.VUE_APP_DB_BLOGS).add({
    author: author,
    body: blog.body,
    coverImage: selectedCoverImage,
    slug_name: sanitizeTitle(title),
    title: title,
    date_created: firestore.Timestamp.fromDate(date),
    date_edited: firestore.Timestamp.fromDate(date),
    published: status,
    project: project
  })
    .then(ref => {
    // set the documentID on the database
      db.collection(process.env.VUE_APP_DB_BLOGS).doc(ref.id).update({ uid: ref.id })
      // add new tags to the database
      tags.forEach((value: any) => {
        db.collection(process.env.VUE_APP_DB_TAGS).add({
          blogId: ref.id,
          tag: value
        })
      })
    })
    .catch(function (error) {
      console.error('Error writing document: ', error)
    })
}

export async function postNewTagsToFirebase (tags: any[]) {
  console.log('postTagsToFirebase Function')
  tags.forEach(async element => {
    db.collection(process.env.VUE_APP_DB_TAGS).add({
      tag: element
    })
  });
}

export async function updatePostTagsToFirebase (tags: any[], blogId) {
  console.log('updatePostTagsToFirebase Function')

  // get the existing document, if it exists

  var docRef = db.collection(process.env.VUE_APP_DB_TAGS_POST).doc(blogId);
  docRef.get().then(function(doc) {
    if (doc.exists) {
        var tags_post = db.collection(process.env.VUE_APP_DB_TAGS_POST).doc(blogId)
        return tags_post.update({
          tags: tags
        }).then(function() {
          console.log("Document successfully updated!");
      })
    } else {
        // doc.data() will be undefined in this case
        db.collection(process.env.VUE_APP_DB_TAGS_POST).doc(blogId).set({
          tags: tags
        })
    }
}).catch(function(error) {
    console.log("Error getting document:", error);
});

  //update it if it exists

  //create if it doesn't
}

export function sanitizeTitle (title: string) {
  let slug = ''
  // Change to lower case
  const titleLower = title.toLowerCase()
  // Letter "e"
  slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e')
  // Letter "a"
  slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a')
  // Letter "o"
  slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o')
  // Letter "u"
  slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u')
  // Letter "d"
  slug = slug.replace(/đ/gi, 'd')
  // Trim the last whitespace
  slug = slug.replace(/\s*$/g, '')
  // Change whitespace to "-"
  slug = slug.replace(/\s+/g, '-')

  return slug
}


export async function deleteFirebaseDocument(collectionName: string, documentId: string) {
  console.log(collectionName)
    var doc = db.collection(collectionName).doc(documentId)
    return doc.delete()
    .then(function() {
        console.log("Document successfully Deleted!");
    })
    .catch(function(error) {
        // The document probably doesn't exist.
        console.error("Error deleting document: ", error);
    });
}

export async function getPostTags(uid: string){
  console.log(uid)
  const collection = db.collection(process.env.VUE_APP_DB_TAGS)
  const data = []
  const query = collection.where('blogId', '==', uid)
  await query.get().then(snapshot => {
    snapshot.docs.forEach(doc => {
      data.push(doc.data())
    })
  })
  return data
  
}